import './components/pagination';
import './components/dealer_list_search';

$(function () {
    // Dealer list sorting from dropdown
    $(document).on('change', '#dealerListing #dealerListOrderBy', function () {
        $('#dealerListSortingForm input[name=dealer_list_sort_column]').val($(this).val().split('_')[0]);
        $('#dealerListSortingForm input[name=dealer_list_order_by]').val($(this).val().split('_')[1]);
        $('#dealerListSortingForm').submit();
    });

    // Dealer list sorting for clicked column name
    $(document).on('click', '#dealerListing .dealerListSortingByColumn', function () {
        $('#dealerListSortingForm input[name=dealer_list_sort_column]').val($(this).data('sortcolumn'));
        $('#dealerListSortingForm input[name=dealer_list_order_by]').val($(this).data('sortorder'));
        $('#dealerListSortingForm').submit();
    });
});
